/* eslint-disable @typescript-eslint/no-explicit-any */
import InsightPickListCard from "features/insights/components/cards/insight-pick-list-card";
import { InsightAdvancedSearchModal } from "features/journey-map/swimlanes/insights/modals/AdvancedSearchModal";
import { useSelector } from "react-redux";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import { SwitchProvider } from "shared/dynamic-imports";
import InsightCreateNewItem from "../components/insight-create-new-item";
import RenderAdvancedModalFooter from "../components/RenderAdvancedFooter";
import { useAIParams } from "./InsightDropdownAI";

interface InsightDropdownProps {
	link?: (id: string, e?: any) => void;
	closeDropdown?: () => void;
	selected?: any;
	isOpen?: boolean;
	isSwitchDisabled?: boolean;
	showShadow?: boolean;
	globalWidth?: string;
	aiParameters?: any;
}

export const InsightDropdown = ({ selected, link, isOpen = false, isSwitchDisabled = false, showShadow = false, closeDropdown, globalWidth ,aiParameters}: InsightDropdownProps): JSX.Element => {

	const showSampleData = useSelector(({ settings }: any) => settings.organization?.showSampleData);
	const allInsights = useSelector((state: any) => state.insights?.all_insights.getActiveRecords(!showSampleData));
	const aiParams = useAIParams({ aiParameters, closeDropdown, link });


	const params: any = {
		selected: [],
		options: allInsights,
		placeholder: "SEARCH_OR_CREATE",
		menuLabel: "SELECT_OR_CREATE",
		renderSelectedItem: () => <></>,
		renderMenuItem: ({ item }: any) => (
			<div className="item-dropdown-typehead-generic"onClick={link ? (e:any) => link(item?.id, e) : undefined}>
				<InsightPickListCard insight={item} />
			</div>
		),
		linkMenuItem: ({ e, item }: any) => {
			if (link) link(item?.id, e);
		},
		filter: ({ query, option }: any) => {
			const ins = allInsights.find((t: any) => t.id === option?.id);
			if (ins && !selected?.includes(ins.id)) return ins?.name?.toLowerCase().includes(query?.toLowerCase());
		},
		renderCreateItem: ({ input, clearInput, close }: any) => <InsightCreateNewItem link={link} input={input} clearInput={clearInput} />,
		isStrictOpen: isOpen ? isOpen : null,
		globalWidth,
		virtualScrollerParams: {
			rowHeight: 96,
		},
		RenderFooter: RenderAdvancedModalFooter({ closeDropdown, link, selected, modal: InsightAdvancedSearchModal }),
		showShadow,
		...aiParams,
	};

	return (
		<SwitchProvider initialValue={isOpen} isDisabled={isSwitchDisabled}>
			<EditModeSwitch addLabel="INSIGHT" isDisabled={isSwitchDisabled} isEmpty={true}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
};


